"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'pattenKpi',
      searchQuery: {
        rsmCode: '',
        rsmName: '',
        asmCode: '',
        asmName: '',
        srCode: '',
        srName: '',
        year: null
      },
      apiModule: 'kpiSet',
      disabledKeyList: ['rsmCode', 'rsmName', 'asmCode', 'asmName']
    };
  },
  computed: {
    domData: function domData() {
      return {
        rsmCode: {
          label: this.$t('sfe.pattenkpi.rsmId'),
          valueKey: 'rsmCode'
        },
        rsmName: {
          label: this.$t('sfe.pattenkpi.rsmName'),
          valueKey: 'rsmName'
        },
        asmCode: {
          label: this.$t('sfe.pattenkpi.asmId'),
          valueKey: 'asmCode'
        },
        asmName: {
          label: this.$t('sfe.pattenkpi.asmName'),
          valueKey: 'asmName'
        },
        srCode: {
          label: this.$t('sfe.pattenkpi.srId'),
          valueKey: 'srCode'
        },
        srName: {
          label: this.$t('sfe.pattenkpi.srName'),
          valueKey: 'srName'
        },
        year: {
          label: this.$t('common.year2'),
          valueKey: 'year',
          inputType: 'date',
          type: 'year'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.pattenkpi'),
          apiUrl: '/protected/monthlyNewProductPatternKpi/export'
        },
        import: {
          apiUrl: '/protected/monthlyNewProductPatternKpi/import'
        }
      };
    },
    tableDom: function tableDom() {
      var month12List = this.createMonth12List();
      return (0, _objectSpread2.default)({
        rsmCode: {
          label: this.$t('sfe.pattenkpi.rsmId')
        },
        rsmName: {
          label: this.$t('sfe.pattenkpi.rsmName')
        },
        asmCode: {
          label: this.$t('sfe.pattenkpi.asmId')
        },
        asmName: {
          label: this.$t('sfe.pattenkpi.asmName')
        },
        srCode: {
          label: this.$t('sfe.pattenkpi.srId')
        },
        srName: {
          label: this.$t('sfe.pattenkpi.srName')
        },
        brand: {
          label: this.$t('common.brand')
        },
        year: {
          label: this.$t('common.year2')
        },
        pattern: {
          label: this.$t('sfe.pattenkpi.pattern')
        }
      }, month12List);
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/monthlyNewProductPatternKpi/list'
      };
    }
  },
  methods: {
    createMonth12List: function createMonth12List() {
      var _this = this;
      var month12 = new Array(12).toString().split(',').map(function (t, i) {
        return i + 1;
      });
      var month12List = {};
      month12.forEach(function (m) {
        var number = m >= 10 ? m : "0".concat(m);
        month12List["targetCount".concat(number)] = {
          label: _this.$t("sfe.pattenkpi.salesMonth".concat(m)),
          isCommasNumber: true
        };
      });
      return month12List;
    }
  }
};